import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor 请求拦截器 languageType
service.interceptors.request.use(
  config => {


    // if (store.getters.token) {
      // config.headers['X-Token'] = getToken()
      // config.headers.Authorization = 'Bearer '+getToken()
    // }
   const language=store.getters.language=="en"?1:0;
    if (config.method === 'get') {  
      if (!config.url.includes('?')) {  
        config.url += `?languageType=${language}`;  
      } else {  
        // 如果已经有参数，我们使用&来添加新的参数  
        config.url += `&languageType=${language}`;  
      }  
    } else if (config.method === 'post' || config.method === 'put') {
      if (config.url.includes('?')) {  
        config.url += `&languageType=${language}`;  
       
      }else if (config.data && typeof config.data === 'object') {  
        config.data.languageType = language; // 直接添加到data对象中  
      }  
    }  

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status *如果您想要获取诸如头或状态之类的http信息
   * Please return  response => response *请返回response=>response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  // response=>response
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.code != 204) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 401 || res.code === 402) {
        // to re-login
        MessageBox.confirm('你还没登录请重新登录', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
         
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err:' +error) // for debug

    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  }
)

export default service
